export enum SellOption {
    TicketOnly = 'ticket_only',
    VoucherOnly = 'voucher_only',
    TicketAndVoucher = 'ticket_and_voucher',
}
